import { RootState } from '@AppState/redux-store'
import { Button, DropdownMenu, Flex } from '@radix-ui/themes'
import { useSelector } from 'react-redux'
import { withAuth0, WithAuth0Props } from '@auth0/auth0-react'
import { useLocation } from 'react-router-dom'
import { setAuthOrg } from '../../config'

export const CustomerSwitcher = withAuth0((auth0Props: WithAuth0Props) => {
  const location = useLocation()
  const { currentUser, activeCustomerId } = useSelector((state: RootState) => state.users)

  const onCustomerChange = async (customerId: string) => {
    const matchingCustomer = currentUser?.customers.find((c) => c.customerId === customerId)

    if (matchingCustomer) {
      // Persist the target org before redirecting so it survives page reload.
      // If the silent login fails (e.g. expired session), the error handler in App.tsx
      // needs this to redirect to the correct org's login page.
      setAuthOrg(matchingCustomer.id)

      // When we switch customers we have to get a new token contextual to the customer we're switching to.
      // prompt: 'none' attempts to do the login silently and reuse the existing session - otherwise prompts for a new login
      await auth0Props.auth0.loginWithRedirect({
        authorizationParams: {
          prompt: 'none',
          organization: matchingCustomer.id,
        },
        appState: { returnTo: location.pathname },
      })
    }
  }

  const availableOptions = currentUser?.customers.map((c) => (
    <DropdownMenu.Item key={c.id} onClick={() => onCustomerChange(c.customerId)}>
      {c.displayName}
    </DropdownMenu.Item>
  ))

  if (!(activeCustomerId && currentUser)) {
    return
  }

  const activeCustomer = currentUser.customers.find((c) => c.customerId === activeCustomerId)

  if (availableOptions?.length == 1) {
    return <span>{activeCustomer!.displayName}</span>
  }

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger>
        <Flex align="center" gap="2" style={{ cursor: 'pointer' }}>
          <Button variant="outline" className="header__switcher">
            {activeCustomer!.displayName}
            <DropdownMenu.TriggerIcon />
          </Button>
        </Flex>
      </DropdownMenu.Trigger>
      <DropdownMenu.Content>{availableOptions}</DropdownMenu.Content>
    </DropdownMenu.Root>
  )
})
